import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusChallengesApi = createApi({
  reducerPath: 'erasmusChallengesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: builder => ({
    getErasmusChallenges: builder.query({
      query: () => ({
        url: urls.erasmusChallenges,
      }),
      transformResponse: (response) => {
        // Ensure we always return an array
        return Array.isArray(response) ? response : [];
      },
    }),
    getErasmusChallenge: builder.query({
      query: id => ({
        url: urls.erasmusChallengeDetail(id),
      }),
    }),
    saveErasmusChallenge: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.erasmusChallengeDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.erasmusChallenges,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteErasmusChallenge: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusChallengeDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetErasmusChallengesQuery,
  useGetErasmusChallengeQuery,
  useSaveErasmusChallengeMutation,
  useDeleteErasmusChallengeMutation,
} = erasmusChallengesApi;
